import SpinRecord, { AnticipationInfo } from "slotworks/model/gameplay/records/spin-record";
import { BuyoutTypes } from "components/bonus-buy/bonus-buy-container";

export default class RainbowStacksSpinRecord extends SpinRecord {
    public multiplier: number = 1
    public wildMultiplier: number = 1;

    public triggersRespin: boolean = false;
    public jackpotSymbol: string = "";

    public buyoutType: BuyoutTypes;
    public totalBetCash: number = 0;
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/integration/revolver/schema/spin-record.ts